import {
    cardOutline,
} from 'ionicons/icons';
import RouteChoice from "../model-factory/basic/route/RouteChoice";
import RouteModel from "../model-factory/basic/route/RouteModel";
import {RouteKey, FactoryID} from "../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../model-factory/basic/route/RouteFactory";
import {getManager} from "../manager/Manager";
import {IRouteIDs} from "../model-factory/type-interface/ModelFactoryInterface";


export class BrowseRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "browse_route_id";

    choiceOrder = ["homepage", "organisation", "project", "offer", "my_profile", "archive", "unpublished", "pending", "site_pages"];
    defaultChoiceID = "homepage";

    applyModelConditionsToRoute()
    {
        super.applyModelConditionsToRoute();
        this.uiChoiceOrder = [
            "project",
            "offer"
        ]
    }
}

export default class BrowseRouteFactory extends RouteFactory
{

    id: FactoryID = "browse_route";

    constructor()
    {
        super();

        this.choices = {
            homepage: new RouteChoice({
                name: "Home",
                pageID: "homepage"
            }),
            organisation: new RouteChoice({
                name: "Organisations",
                nextFactoryID: "post_list_route",
                derivedRouteIDs: {
                    post_type: "organisation"
                }
            }),
            project: new RouteChoice({
                name: "Projects",
                nextFactoryID: "post_list_route",
                derivedRouteIDs: {
                    post_type: "project"
                },
                pageID: "projects"
            }),
            offer: new RouteChoice({
                name: "Offers",
                nextFactoryID: "post_list_route",
                derivedRouteIDs: {
                    post_type: "offer"
                },
                pageID: "offers"
            }),
            my_profile: new RouteChoice({
                name: "My Profile",
                nextFactoryID: "my_profile_route",
                requiresLogin: true,
                calculateRouteIDs: () => {
                    const routedIDs:IRouteIDs = {};
                    const organisationID = getManager().user.organisationID;
                    if(organisationID){
                        routedIDs.organisation_id = organisationID;
                    }
                    return routedIDs
                }
            }),
            archive: new RouteChoice({
                name: "Archive",
                nextFactoryID: "post_status_route",
                isSecondaryRoute: true,
                derivedRouteIDs: {
                    post_status: "expired"
                }
            }),
            unpublished: new RouteChoice({
                name: "Unpublished",
                nextFactoryID: "post_status_route",
                isSecondaryRoute: true,
                derivedRouteIDs: {
                    post_status: "draft",
                    authorization_is_expected: true
                }
            }),
            pending: new RouteChoice({
                name: "Pending Review",
                nextFactoryID: "post_status_route",
                isSecondaryRoute: true,
                derivedRouteIDs: {
                    post_status: "pending",
                    authorization_is_expected: true
                }
            }),
            site_pages: new RouteChoice({
                name: "Site Pages",
                pageID: "site_pages",
                nextFactoryID: "sub_page_route",
                isSecondaryRoute: true,
            }),
        }
    }

    birth(id: FactoryID): BrowseRouteModel
    {
        return new BrowseRouteModel(id);
    }

    getDefaultModel(): BrowseRouteModel
    {
        return this.getDefaultModelWithRoute()! as BrowseRouteModel;
    }
}